var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b438c9fd-d494-44ba-a31a-7e041349337c",
    "data-name": "b24b061c-3b2b-4d15-bb12-3d4cb3cc1ddf",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.6 20.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a741b0f7-3fef-4475-b25e-9085d4d5503a{fill:#00008b;}.a4d9dd1c-62ea-4150-89ad-26842232dbbd,.b3280368-ffdc-4474-b6d0-1d26e1738655{fill:#fff;}.b3280368-ffdc-4474-b6d0-1d26e1738655{fill-rule:evenodd;}.e36d99f2-72fb-49a6-beca-1bbffea4039b{fill:red;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a741b0f7-3fef-4475-b25e-9085d4d5503a",
    width: 29.5,
    height: 20.55,
    rx: 0.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "8.6 12.3 9.2 14 10.8 13.4 9.9 14.9 11.4 15.8 9.6 15.9 9.9 17.7 8.6 16.4 7.4 17.7 7.6 15.9 5.9 15.8 7.4 14.9 6.4 13.4 8.1 14 8.6 12.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "23.2 15.4 23.4 16.2 24.2 15.9 23.8 16.6 24.5 17 23.6 17.1 23.8 17.9 23.2 17.3 22.6 17.9 22.7 17.1 21.9 17 22.6 16.6 22.1 15.9 22.9 16.2 23.2 15.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "23.2 2.8 23.4 3.6 24.2 3.3 23.8 4 24.5 4.4 23.6 4.5 23.8 5.3 23.2 4.7 22.6 5.3 22.7 4.5 21.9 4.4 22.6 4 22.1 3.3 22.9 3.6 23.2 2.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "19.5 7.9 19.7 8.7 20.5 8.4 20 9.1 20.8 9.5 19.9 9.6 20 10.5 19.5 9.8 18.9 10.5 19 9.6 18.1 9.5 18.9 9.1 18.4 8.4 19.2 8.7 19.5 7.9"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "27.4 6.6 27.6 7.4 28.4 7.1 28 7.8 28.7 8.3 27.8 8.4 28 9.2 27.4 8.6 26.8 9.2 26.9 8.4 26.1 8.3 26.8 7.8 26.3 7.1 27.1 7.4 27.4 6.6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b3280368-ffdc-4474-b6d0-1d26e1738655",
    points: "25.1 10.4 25.3 10.9 25.8 11 25.4 11.3 25.5 11.8 25.1 11.6 24.6 11.8 24.7 11.3 24.3 11 24.9 10.9 25.1 10.4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a4d9dd1c-62ea-4150-89ad-26842232dbbd",
    d: "M0,.8,15,8.4h1.9v-1L1.6,0H.4C-.1.2.1.4,0,.8ZM16.9,0V.7L1.5,8.4H0v-1L15,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a4d9dd1c-62ea-4150-89ad-26842232dbbd",
    d: "M7,0V8.4H9.8V0ZM0,2.8V5.6H16.9V2.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e36d99f2-72fb-49a6-beca-1bbffea4039b",
    d: "M0,3.3V5H16.9V3.3ZM7.6,0V8.4H9.3V0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e36d99f2-72fb-49a6-beca-1bbffea4039b",
    d: "M0,8,4.6,5.6H5.9L.3,8.4H0ZM.4.3.7,0,6.3,2.7H5Zm9.8,2.5L15.8,0h1.1L11.4,2.8Zm6.3,5.6L11,5.7h1.4l4.5,2.2v.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAus);
export default __webpack_public_path__ + "static/media/aus.54bd24f906af237502487dff5f62f0e0.svg";
export { ForwardRef as ReactComponent };